import { RRRFieldWithValidation } from "./field-with-validation";
import { RRRPhoneNumber } from "./phone-number";

type RRRElementClass = (new () => HTMLElement) & { tagName: string };

export default function defineCustomElements() {
    const klasses: RRRElementClass[] = [
        RRRFieldWithValidation,
        RRRPhoneNumber,
    ];

    for (const klass of klasses) {
        customElements.define(klass.tagName, klass);
    }
};
